module.exports = __webpack_public_path__ + "img/shuidi2.a6707d76.png";